var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M16.8759 10.1123C16.8759 9.46481 16.8223 8.99231 16.7063 8.50232H9.16162V11.4248H13.5902C13.5009 12.1511 13.0188 13.2448 11.9473 13.9798L11.9323 14.0776L14.3178 15.8887L14.483 15.9048C16.0009 14.5311 16.8759 12.5098 16.8759 10.1123Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M9.16098 17.8124C11.3306 17.8124 13.152 17.1124 14.4824 15.9049L11.9467 13.9799C11.2681 14.4436 10.3574 14.7674 9.16098 14.7674C7.03601 14.7674 5.23246 13.3936 4.58954 11.4949L4.4953 11.5027L2.01486 13.384L1.98242 13.4724C3.30383 16.0449 6.01811 17.8124 9.16098 17.8124Z",
    fill: "#009E5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M4.59022 11.4949C4.42059 11.0049 4.32241 10.4798 4.32241 9.93735C4.32241 9.39482 4.42059 8.86984 4.5813 8.37984L4.57681 8.27549L2.06527 6.36401L1.9831 6.40232C1.43848 7.46983 1.12598 8.6686 1.12598 9.93735C1.12598 11.2061 1.43848 12.4048 1.9831 13.4723L4.59022 11.4949Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M9.16103 5.10736C10.6699 5.10736 11.6878 5.7461 12.2682 6.27989L14.536 4.10988C13.1432 2.84113 11.3306 2.06238 9.16103 2.06238C6.01814 2.06238 3.30384 3.82986 1.98242 6.40234L4.58063 8.37987C5.23248 6.48112 7.03604 5.10736 9.16103 5.10736Z",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.65dd59c24566e0b70a26ffec2dcb70e2.svg";
export { ForwardRef as ReactComponent };